import { SubVersionFormInput } from "@graphql";

export type FormData = SubVersionFormInput & { fileName?: string };

export const initialValues: FormData = {
  basicPrice: null,
  consultantId: null,
  startDate: null,
  endDate: null,
  fileName: null
};
